import { useTranslation } from "react-i18next";
import {
  getCategories,
  getTemplatesByCategory,
  type ItemTemplate,
} from "../lib/templates";
import { ItemThumbnail } from "./ItemThumbnail";

type Props = {
  onSelect: (template: ItemTemplate) => void;
};

export function TemplateGrid({ onSelect }: Props) {
  const { t } = useTranslation(["templates", "common"]);
  const categories = getCategories();

  return (
    <div className="space-y-6">
      {categories.map((categoryKey) => (
        <div key={categoryKey}>
          <h3 className="mb-2 px-1 text-xs font-bold text-gray-500">
            {t(categoryKey)}
          </h3>
          <div className="grid grid-cols-2 gap-2">
            {getTemplatesByCategory(categoryKey).map((template) => {
              return (
                <button
                  type="button"
                  key={template.nameKey}
                  onClick={() => onSelect(template)}
                  className="flex min-h-16 items-center gap-3 rounded-[14px] border border-[#e3e8f0] bg-white px-3 py-2.5 text-left transition-colors hover:border-blue-300 hover:bg-[#edf3ff]"
                >
                  <ItemThumbnail iconUrl={template.iconUrl} />
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-xs font-bold text-gray-800">
                      {t(template.nameKey)}
                    </span>
                    <span className="mt-0.5 block text-[11px] text-gray-400">
                      {t("common:units.days", { count: template.intervalDays })}
                    </span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
